module.exports = __webpack_public_path__ + "static/img/news_banner2.be2a5a9a.png";